import React from "react";

export const CategoryContext = React.createContext([]);
export const ArticleContext = React.createContext([]);
export const KBContext = React.createContext([]);
export const SearchContext = React.createContext([]);